<template>
    <van-row class="header_container" :style="{ backgroundColor: props.bgColor }">
        <van-col span="3" class="header_col">
            <div class="back_btn" v-if="!hideBacKIcon" @click="handleBackClick">
                <img src="@/assets/common/backIcon.png" alt="">
            </div>
        </van-col>
        <van-col span="18" class="header_col">
            {{ props.text }}
        </van-col>
        <van-col span="3" class="history-col" v-if="showHistory">
            <div @click="() => emits('openHistoryPopup')">
                {{ $t('common.history') }}
                <van-icon name="play" style="padding-top: 2px;" />
            </div>
        </van-col>
        <van-col span="3" class="history-col" v-if="showFund">
            <!-- <div @click="() => emits('goToFund')">
                <van-icon name="orders-o" size="25"/>
            </div> -->
            <img src="@/assets/common/file.png" alt=""  @click="() => emits('goToFund')" style="width: 22px;"/>
        </van-col>
    </van-row>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { navToBack } from '@/view/components/supportFunction'
import { useRouter } from 'vue-router'
const router = useRouter()
const userStore = useUserStore()
const props = defineProps({
    text: {
        type: String,
        default: () => ''
    },
    isShowRightIcon: {
        type: Boolean,
        default: () => false
    },
    isPopupCloseBackIcon: {
        type: Boolean,
        default: () => false
    },
    showHistory: {
        type: Boolean,
        default: () => false
    },
    showFund: {
        type: Boolean,
        default: () => false
    },
    isFinalizar: {
        type: Boolean,
        default: () => false,
        required: false
    },
    bgColor:{
        type: String,
        default: () => '#164489'
    },
    hideBacKIcon:{
        type: Boolean,
        default: () => false,
        required: false
    }
})
const emits = defineEmits(['closePopup', 'openHistoryPopup', 'goToFund'])

const handleBackClick = () => {
    navToBack(router, props.isPopupCloseBackIcon, emits)
    userStore.setRechargeBonusType(0)
}

</script>
<style scoped>
.header_container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    color: #FFF;
    padding: 18px 5px;
    z-index: 1000;
}

.back_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 25px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.25s ease;
}

.back_btn:hover {
    background-color: #ffffff14; 
}

.back_btn:active {
    transform: scale(0.92);
}

.header_col img {
    width: 16px;
    
}

.header_col {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
}

.history-col {
    font-size: 0.65rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    text-align: center;
}

@media (max-width: 450px){
    .header_col{
        font-size: 16px;
    }
}
</style>